import React, {
    useState,
    useEffect,
} from 'react';

import { getBasketData } from "../queries/global"
import LoadingIndicator from './loading-indicator';

import * as UTILS from "../utils/utils";

export default function BasketSummary() {

    const { data: basketData, isPending: basketDataPending } = getBasketData();

    const [deliveryAmount, setDeliveryAmount] = useState(null);
    const [basketTotal, setBasketTotal] = useState(null);
    const [excludedDonations, setExcludedDonations] = useState([]);

    useEffect(() => {
        if (!basketData || !basketData.tickets) return;

        const delivery_amount = UTILS.getDeliveryAmount(basketData);
        setDeliveryAmount(delivery_amount);

        let basket_total = basketData.total;
        if (basket_total < 0) {
            basket_total = 0;
        }
        setBasketTotal(basket_total);

        const excluded_donations = UTILS.getExcludedDonations(basketData);
        setExcludedDonations(excluded_donations);

    }, [basketData]);

    if (!basketData) return;
    if (basketDataPending) return <LoadingIndicator />;

    return (
        <section className='basket-summary'>
            {/* {basketData.membershipSubscriptions.length ? 
                basketData.membershipSubscriptions.map((membership) => (
                    <p key={membership.id} className='basket-summary__item'>
                        <span>{membership.membership.name} Membership</span>
                        <span>£{membership.membership.price.toFixed(2)}</span>
                    </p>
                ))
                : null
            } */}

            {/* {basketData.donations.length > 0 &&
                basketData.donations.map(donation => {
                    if (excludedDonations.includes(donation.id)) return null;

                    return (
                        <p key={donation.id} className='basket-summary__item'>
                            <span>Donation</span>
                            <span>£{donation.amount.toFixed(2)}</span>
                        </p>
                    );
                })
            } */}

            {/* {basketData.giftVouchers.length ? 
                basketData.giftVouchers.map((voucher) => (
                    <p key={voucher.id} className='basket-summary__item'>
                        <span>Gift voucher</span>
                        <span>£{voucher.amount.toFixed(2)}</span>
                    </p>
                ))
                : null
            } */}
            {deliveryAmount && deliveryAmount > 0 ? 
                <p className='basket-summary__item'>
                    <span>Delivery</span>
                    <span>£{deliveryAmount}</span>
                </p>
                : null
            }
            {/* {basketData.totalDiscount ? 
                <p className='basket-summary__item'>
                    <span>Discount</span>
                    <span>-£{basketData.totalDiscount.toFixed(2)}</span>
                </p>
                : null
            } */}
            {basketData.transactionCommission && !basketData.customer?.subscriptions?.length && !basketData.membershipSubscriptions?.length && basketData.transactionCommission.amount > 0 ? 
                <p className='basket-summary__item'>
                    <span>Booking fee</span>
                    <span>£{basketData.transactionCommission.amount.toFixed(2)}</span>
                </p>
                : null
            }
            {basketTotal ?
                <p className='basket-summary__total'>
                    <span>Total</span>
                    <span>£{basketTotal.toFixed(2)}</span>
                </p>
                :null
            }
        </section>
    );
}